module.exports = __webpack_public_path__ + "static/media/person.5cd51f56.png";